import { api } from './api';
import { AppConfig } from '@/types/config';

export const getAppConfig = async (): Promise<AppConfig> => {
    const response = await api.get<AppConfig>('/config');
    return response.data;
};
